enum SessionStorage {
    CORE_USER_FILTER = 'dy_internal/filter/core-user',
    CLIENT_USER_FILTER = 'dy_internal/filter/client-user',
    TASK_FILTER = 'dy_internal/filter/task',
    TASK_CLIENT_FEEDBACK_FILTER = 'dy_internal/filter/task-client-feedback',
}

export default SessionStorage;
